export var QuestionPageTheme;
(function (QuestionPageTheme) {
    QuestionPageTheme["Blue"] = "blue";
    QuestionPageTheme["Light"] = "light";
})(QuestionPageTheme || (QuestionPageTheme = {}));
//# sourceMappingURL=themes.types.js.map